import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const COMPANY_ID_MAX_LENGTH = 8;
export const COMPANY_ID_MIN_LENGTH = 8;
export const COMPANY_ID_SCHEMA_FIELD_NAME = "companyId";
const companyIdRegex = /^99|94|97/;

export const getCompanyIdFormFieldSchema = (label = i18n("CompanyIdFormField__LABEL")) =>
  yup
    .string()
    .trim()
    .required()
    .label(label)
    .max(COMPANY_ID_MAX_LENGTH)
    .min(COMPANY_ID_MIN_LENGTH)
    .matches(companyIdRegex);
